import { serializable } from "serializr";

export class CoProducts {

  @serializable
  name = null;

  @serializable
  allocation = null;

  @serializable
  emission = null;

}